import { prepareMetadata, type Metadata } from '@littlebird/logger';

const SYNC_CONTEXT_PREFIXES = [
  'SyncProcessor',
  'TransactionQueue',
  'BootstrapManager',
  'Store:rollback',
  'SyncRunReport',
];

export type SyncLogScalars = Record<string, string | number | boolean | null>;

export function syncLogContext(
  metadata: Metadata | undefined
): string | undefined {
  const context = metadata?.context;
  return typeof context === 'string' &&
    SYNC_CONTEXT_PREFIXES.some((prefix) => context.startsWith(prefix))
    ? context
    : undefined;
}

function scalarsOnly(input: unknown): SyncLogScalars {
  const out: SyncLogScalars = {};
  if (input === null || typeof input !== 'object') return out;
  for (const [key, value] of Object.entries(input as Record<string, unknown>)) {
    if (
      value === null ||
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      out[key] = value;
    }
  }
  return out;
}

export function syncLogScalars(metadata: Metadata | undefined): SyncLogScalars {
  if (!metadata) return {};
  const { engineContext, ...fields } = (prepareMetadata(metadata).metadata ??
    {}) as Record<string, unknown>;
  return { ...scalarsOnly(fields), ...scalarsOnly(engineContext) };
}
